import { PdfEntityByAcademicYearList } from 'components/pdfStudent';
import { splitEntitiesByAcademicYear } from 'containers/pdfStudent/utils/splitEntitiesByAcademicYear';
import { useAppSelector, useDataLoad } from 'hooks';
import { IconWidgetScienceEmployments } from 'icons/widgets';
import PdfNoDataText from 'portfolio3/features/pdf/components/PdfNoDataText';
import { chosenAcademicYearsListSelector } from 'portfolio3/features/pdf/model/selectors';
import { getDataLoadRequests } from 'utils';

import { scienceOccupationsSelector } from '../../../../selectors';
import PdfCommonDataEntityContainer from '../common';

import '../index.scss';

const PdfScienceOccupationContainer = () => {
  const academicYears = useAppSelector(chosenAcademicYearsListSelector);
  const studentOccupations = useAppSelector(scienceOccupationsSelector);
  useDataLoad({ shouldLoad: true, requests: getDataLoadRequests().scienceOccupations });

  const hasData = studentOccupations.content.length > 0;
  const academicYearData = splitEntitiesByAcademicYear(studentOccupations, academicYears);

  return (
    <PdfCommonDataEntityContainer title="Занятия" Icon={IconWidgetScienceEmployments}>
      {hasData && <PdfEntityByAcademicYearList academicYearData={academicYearData} />}
      {!hasData && <PdfNoDataText />}
    </PdfCommonDataEntityContainer>
  );
};

export default PdfScienceOccupationContainer;
